import { render, staticRenderFns } from "./DistribuirCaixasFormCarga.vue?vue&type=template&id=24bed799&"
import script from "./DistribuirCaixasFormCarga.vue?vue&type=script&lang=js&"
export * from "./DistribuirCaixasFormCarga.vue?vue&type=script&lang=js&"
import style0 from "./DistribuirCaixasFormCarga.vue?vue&type=style&index=0&id=24bed799&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports